import AppDialog from "../../../components/Common/AppDialog"
import { Grid } from "@mui/material";
import moment from "moment";
import { connect } from "react-redux";

const InventoryVehicleDetailsSummaryModal = ({ isSingPass, open, close, windowWidth, selectedVehicle, bodyList, makeList, modelList, invType }) => {
    const selectedMake = makeList?.find(make => String(make.id) === String(selectedVehicle?.bike_make_id));
    const availableModels = selectedMake?.models || modelList || [];
    const selectedModel = availableModels.find(model => String(model.id) === String(selectedVehicle?.bike_model_id));
    const selectedColour = selectedModel?.colours?.find(
        colour => String(colour.id) === String(selectedVehicle?.bike_model_colour_id),
    );
    const colourName = selectedColour?.name
        || selectedVehicle?.color
        || selectedVehicle?.colour
        || selectedVehicle?.colour_text
        || '-';
    return (
        <AppDialog
            open={open}
            close={close}
            vehicleData={selectedVehicle}
            title={`${selectedVehicle?.make || "-"} ${selectedVehicle?.model || "-"} ${selectedVehicle?.manu_year ? `(${selectedVehicle?.manu_year})` : ''}`}
            positiveTitle={'Close'}
            positivePress={() => close()}
            width={'45%'}
            isMobile={windowWidth <= 768 ? true : false}
        >
            <Grid container spacing={2}>
                <Grid item lg={6} md={5} sm={12} xs={12} className="subheader-3">Make / Model</Grid>
                <Grid item lg={6} md={7} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.make} / {selectedVehicle?.model}
                </Grid>
                {invType !== 'new' && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Number</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.reg_no || '-'}
                    </Grid>
                </>}
                {!isSingPass && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock ID</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.stock_id || '-'}
                    </Grid>
                </>}
                <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Body Type</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {Array.isArray(selectedVehicle?.body_type) && selectedVehicle?.body_type.length > 0 ? selectedVehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ') : selectedVehicle?.body_type || '-'}
                    </Grid>
                </>
                {!isSingPass && (
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Primary Colour</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {colourName}
                        </Grid>
                    </>
                )}
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Year of Manufacture</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.manu_year || '-'}
                </Grid>
                {invType === "used" && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Date</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.reg_date ? moment(selectedVehicle?.reg_date, "YYYY-MM-DD").format('DD MMM YYYY') : selectedVehicle?.first_reg_date ? moment(selectedVehicle?.first_reg_date, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}
                    </Grid>
                </>}
                {!isSingPass && (
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Category</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.coe_category || '-'}
                        </Grid>
                    </>
                )}
                {invType === "used" && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Expiry Date</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.coe_expiry ? moment(selectedVehicle?.coe_expiry, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}
                    </Grid>
                </>}
                {
                    invType !== "new" && (
                        <>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Number of Previous Owner</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                                {selectedVehicle?.no_of_owner || '0'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Mileage (KM)</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                                {selectedVehicle?.mileage || '0'}
                            </Grid>
                        </>
                    )}
                {isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Owner Name</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.name || '-'}
                        </Grid>
                    </>}
                {/* {!isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock Status</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.stock_status || '-'}
                        </Grid>
                    </>} */}
                <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Internal Remarks</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.internal_remarks || '-'}
                    </Grid>
                </>
            </Grid>
        </AppDialog>
    )
}

function mapStateToProps({ General }) {
    return {
        makeList: General.bike_makes,
        modelList: General.bike_models,
    };
}

export default connect(mapStateToProps)(InventoryVehicleDetailsSummaryModal);
